var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBatteryHealth0 = function SvgBatteryHealth0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.581 0c1.19 0 1.62.124 2.055.356.434.233.775.574 1.008 1.008.232.435.356.866.356 2.055v4.496c0 1.189-.124 1.62-.356 2.054a2.425 2.425 0 0 1-1.008 1.008c-.435.233-.866.356-2.055.356H3.42c-1.19 0-1.62-.123-2.055-.356A2.43 2.43 0 0 1 .356 9.97C.124 9.535 0 9.104 0 7.915V3.419c0-1.19.124-1.62.356-2.055A2.448 2.448 0 0 1 1.364.356C1.8.124 2.23 0 3.42 0h15.16zm0 1H3.42c-.933 0-1.254.062-1.583.238a1.43 1.43 0 0 0-.598.598c-.176.329-.238.65-.238 1.583v4.496c0 .933.062 1.253.238 1.583.14.26.338.458.598.597.329.176.65.238 1.583.238h15.16c.933 0 1.254-.062 1.583-.238.26-.139.459-.337.598-.597.176-.33.238-.65.238-1.583V3.419c0-.933-.062-1.254-.238-1.583a1.43 1.43 0 0 0-.598-.598C19.834 1.062 19.513 1 18.58 1zM23 3.667a2.169 2.169 0 0 1 0 4z"
  })));
};

export default SvgBatteryHealth0;